import { FadeIn } from "./FadeIn";
import { CREDENTIALS } from "@/content";

export const Credentials = () => (
  <section id="credentials" data-testid="credentials-section" className="bg-[#F6F5F2] px-6 py-28 lg:px-10 lg:py-40">
    <div className="mx-auto max-w-5xl">
      <FadeIn>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-[#D18237]">{CREDENTIALS.overline}</p>
        <h2 className="max-w-2xl font-serif text-3xl leading-tight tracking-tight text-[#0A0F16] md:text-5xl">
          {CREDENTIALS.title}
        </h2>
        <p className="mt-8 max-w-2xl text-base leading-[1.9] text-[#4A525B] md:text-lg">{CREDENTIALS.intro}</p>
      </FadeIn>
      <div className="mt-16">
        {CREDENTIALS.items.map((item, i) => (
          <FadeIn key={i} delay={i * 0.04}>
            <div data-testid={`credential-row-${i}`} className="grid gap-2 border-t border-[#D8D4CA] py-6 transition-colors duration-500 hover:bg-white/50 md:grid-cols-[64px_1fr] md:gap-10">
              <p className="font-serif text-xl text-[#D18237]">{String(i + 1).padStart(2, "0")}</p>
              <p className="text-sm leading-relaxed text-[#4A525B] md:text-base">
                {item.before}
                {item.linkLabel && (
                  <a
                    data-testid={`credential-link-${i}`}
                    href={item.linkUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="font-medium text-[#122336] underline decoration-[#D18237] underline-offset-4 transition-colors duration-300 hover:text-[#D18237]"
                  >
                    {item.linkLabel}
                  </a>
                )}
                {item.after}
              </p>
            </div>
          </FadeIn>
        ))}
        <div className="border-t border-[#D8D4CA]" />
      </div>
    </div>
  </section>
);
